import React from 'react';
import PropTypes from 'prop-types';

import { NotifyOutsideClick } from 'core/components';
import { GlobalTaskNotifications } from 'application/global-task-notifications/components';
import {defaultTemplate} from 'core/hoc';
import _ from 'lodash';

function HeaderTemplate({ rootStore, routerStore, t, menuStore, breadcrumbs }) {
    const {
        viewStore: {
            toggleProfileMenu,
            setProfileMenu,
            profileMenuOpen
        },
    } = rootStore;

    const lastIndex = breadcrumbs.length - 1;
    return (
        <header className={menuStore.isCollapsed ? "layout__header header is-collapsed" : "layout__header header"}>
            <div className="header__hamburger" onClick={() => menuStore.toggleMenuOpen()}>
                <i className="u-icon u-icon--xmed u-icon--menu"></i>
            </div>
            <div className="breadcrumbs">
                {_.map(breadcrumbs, (breadcrumb, index) => {
                    const isLast = index === lastIndex;
                    const navigate =
                        breadcrumb.route && !isLast ?
                        (
                            breadcrumb.params ? 
                            () => routerStore.goTo(breadcrumb.route, { id:  breadcrumb.params.id, facilityOrderId: breadcrumb.params.facilityOrderId }):
                            () => routerStore.goTo(breadcrumb.route)
                        ) : null;

                    const breadcrumbTitle = t(breadcrumb.title);
                    return (
                        <span className={'breadcrumbs__item' + (!navigate ? ' disabled' : '')} key={index} {...(navigate ? { onClick: navigate } : {})}>
                            {breadcrumbTitle}{isLast ? '' : <span className='breadcrumbs__spacer u-icon u-icon--tny u-icon--arrow-right' /> }
                        </span>
                    );
                })} 
            </div>
            <div className="header__options">
                {/* 
                    uncomment this if you need to debug session expiration modal
                    
                    <button onClick={()=>{
                        rootStore.authStore.token = null;
                    }}>Invalidate token</button> 
                    <button type='button' onClick={clearToken}>CLEAR</button>
                */}

                {/*<button type="button" onClick={clearToken}>CLEAR</button>*/}
                {rootStore.userStore.applicationUser && !rootStore.userStore.applicationUser.roles.includes("Purchasers") && <GlobalTaskNotifications />}
                <div className="header__profile">
                <NotifyOutsideClick action={() => setProfileMenu(false)}>
                        <div>
                            {rootStore.userStore.user ? (
                                <div className="header__profile__name" onClick={toggleProfileMenu}>
                                    <span>{rootStore.userStore.user.displayName}</span>
                                    <i className="u-icon u-icon--xmed u-icon--arrow-down"></i>
                                </div>
                            ) : null}

                            <div className={'header__profile__dropdown' + (profileMenuOpen ? ' active' : '')}>
                                <ul>
                                    <li className='header__profile__dropdown__item'
                                        onClick={() => {
                                            toggleProfileMenu();
                                            routerStore.goTo('master.app.main.my-profile', {id: rootStore.userStore.applicationUser.id})
                                        }}> {t('HEADER.USER_MENU.MY_PROFILE')}
                                    </li>
                                    <li className='header__profile__dropdown__item'
                                        onClick={() => {
                                            rootStore.viewStore.logout();
                                            toggleProfileMenu();
                                        }}> {t('HEADER.USER_MENU.LOGOUT')}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </NotifyOutsideClick>
                </div>
            </div>
        </header>
    );
}

HeaderTemplate.propTypes = {
    rootStore: PropTypes.object,
    routerStore: PropTypes.object,
    menuStore: PropTypes.object,
    t: PropTypes.func,
    breadcrumbs: PropTypes.any
};

export default defaultTemplate(HeaderTemplate);
